import { CMS } from '@waitroom/models';

export const isLinkDefined = <T extends CMS.Link>(link: T | undefined): link is T =>
  !!link?.text?.length;
